/*
 * @Author: Jsonz1993
 * @Date: 2021-01-14 14:42:35
 * @Email: v_gxzhang@tecent.com
 * @LastEditors: Jsonz1993
 * @LastEditTime: 2021-01-14 14:42:36
 * @Description: file content
 */

function isDevelopment() {
  return process?.env?.NODE_ENV === 'development';
}

function isQuietMode() {
  return process?.env?.DEVELOP_MODE === 'quiet';
}

function isProduction() {
  return process?.env?.NODE_ENV === 'production';
}

export { isDevelopment, isQuietMode, isProduction };
